// extracted by mini-css-extract-plugin
module.exports = {"body":"ChangeBonusReleaseDateForm__body--3SYrQ"};